import React from 'react';
import './ResearchMaintenancePage.css';

const researchAreas = [
  {
    title: 'Public-Source Collection',
    description:
      'Continuous collection from public feeds, newsletters, and web-accessible reporting sources with normalization, filtering, and source-aware ingestion rules.',
  },
  {
    title: 'Event Aggregation',
    description:
      'Cross-source clustering, duplicate suppression, and storyline formation across overlapping reports about the same underlying event.',
  },
  {
    title: 'Pattern Analysis',
    description:
      'Trend detection, ranking shifts, source diversity analysis, and retrieval workflows for surfacing emerging patterns in large reporting streams.',
  },
];

const backendStatus = [
  'Backend collection, enrichment, and indexing pipelines remain active.',
  'The public dashboard is temporarily offline while the frontend is being rewritten around research methods, evaluation, and case studies.',
  'API, storage, and analysis infrastructure are still being used for ongoing project work.',
];

const researchQuestions = [
  'How should public reporting streams be clustered into coherent event groups instead of treated as isolated articles?',
  'Which ranking signals best separate persistent developments from short-lived duplication or noise?',
  'How can retrieval and synthesis be evaluated under real constraints such as latency, drift, and uneven source quality?',
];

const ResearchMaintenancePage = () => {
  return (
    <div className="research-page">
      <div className="research-shell">
        <div className="research-banner">
          Public frontend temporarily offline. Backend collection, indexing, and research workflows remain active.
        </div>

        <main className="research-main">
          <section className="research-hero">
            <p className="research-kicker">Smart-Trends.io</p>
            <h1>
              Research project on public-source collection, event aggregation, and
              cross-source pattern analysis.
            </h1>
            <p className="research-summary">
              Smart-Trends is a research systems project built around large-scale collection,
              event grouping, retrieval, ranking, and AI-assisted analysis over evolving public
              reporting streams. The next public frontend will focus on methods, system design,
              evaluation, and selected case studies rather than a generic product dashboard.
            </p>

            <div className="research-actions">
              <a
                className="research-button research-button-primary"
                href="https://api.smart-trends.io"
                target="_blank"
                rel="noopener noreferrer"
              >
                Backend API
              </a>
              <a
                className="research-button research-button-secondary"
                href="https://robbysneiderman.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                Personal Site
              </a>
              <a
                className="research-button research-button-secondary"
                href="mailto:robbysneiderman@gmail.com"
              >
                Contact
              </a>
            </div>
          </section>

          <section className="research-grid">
            <div className="research-card">
              <h2>Current Status</h2>
              <ul>
                {backendStatus.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>

            <div className="research-card">
              <h2>System Emphasis</h2>
              <p>
                The public site is being repositioned to emphasize collection strategy, event
                clustering, retrieval quality, ranking behavior, and evaluation instead of a
                consumer-facing news shell.
              </p>
            </div>
          </section>

          <section className="research-card research-question-card">
            <h2>Research Questions</h2>
            <ul>
              {researchQuestions.map((question) => (
                <li key={question}>{question}</li>
              ))}
            </ul>
          </section>

          <section className="research-areas">
            <h2>Current Workstreams</h2>
            <div className="research-area-grid">
              {researchAreas.map((area) => (
                <article key={area.title} className="research-area-card">
                  <h3>{area.title}</h3>
                  <p>{area.description}</p>
                </article>
              ))}
            </div>
          </section>
        </main>
      </div>
    </div>
  );
};

export default ResearchMaintenancePage;
